export default __webpack_public_path__ + "static/mobile_KV14-22806448a18f143770e0478230d0f21b.mp4";